export default "__VITE_ASSET__81a0e35f__"